export class BaseUnit {
  isn: number;
  companyPartNumber: string;
  manufacturerPartNumber: string;
  companySerialNumber: string;
  manufacturerSerialNumber: string;
  location: string;
  position: string;
  status: string;
  department: string;
  aircraftInstalledCpn: string;
  dateLastActivity: Date;
  userField: string;
  aircraftInstalledMinutes: number;
  aircraftInstalledCycles: number;
  aircraftInstalledDate: Date;
  parentCpn: string;
  parentSerial: string;
  serialDate: Date;
  lastRemovedAcn: string;
  lastRemovedPosition: string;
  lastRemovedDate: Date;
  moduledStd: string;
  engine: string;
  tagNumber: string;
  tagStartDate: Date;
  tagCompleteDate: Date;
  tagDueDate: Date;
  tagQuantity: number;
  tagStatus: string;
  tagShopDate: Date;
  tagShopManHours: number;
  tagManHours: number;
  tagExpedite: string;
  tagRouteOcc: number;
  blStaRtn: string;
  blAirline: string;
  blAirlineName: string;
  blSta: string;
  blDate: Date;
  ata: number;
  discrepancyNumber: number;
  resvNumber: string;
  movementStatus: string;
  shipmentIct: number;
  trackShipDate: Date;
  trackShipStation: string;
  trackShipDepartment: string;
  trackReceivingDate: Date;
  trackReceivingStation: string;
  trackReceivingDepartment: string;
  shopEstimatedManHours: string;
  shopEstimatedMachineHours: string;
  planBuyCode: string;
  lastRarDate: Date;
  repairOrderNumber: string;
  wlHours: string;
  wlCycles: string;
  wlDays: string;
  wlDate: string;
  wlType: string;
  scrapNumber: number;
  scrapDate: Date;
  scrapStatus: string;
  disposition: string;
  fspecLastComp: number;
  trackingLevel: number;
  aircraftFlag: string;
  llPartHistory: string;
  scrapOpenDate: Date;
  scrapChangeDate: Date;
  tagRrNumber: string;
  tagPoSo: string;
  tagStaLoc: string;
  tagInstalledCpn: string;
  tagInstalledSerial: string;
  tagAircraft: string;
  tagPositionCode: string;
  tagNextHigherAssyCpn: number;
  tagNextHigherAssySerial: string;
  tagNextHigherAssyPosition: string;
  tagReason: string;
  tagWriMWo: string;
  timesIncorrectFlag: string;
  ateHours: number;
  claimNumber: number;
  scrapRevModFlag: string;
  blDocNumber: string;
  taggedEmployee: string;
  applicationCode: string;
  transactionName: string;
  intentCode: string;
  transactionTime: Date;
  transactionUserId: string;
  terminalId: string;
  moduleName: string;
  manufacturersServiceDate: Date;
  slExpDate: Date;
  maintenanceWorkOrderNumber: string;
  maintenanceResolutionDate: Date;
  maintenanceTextKey: number;
  maintenanceRequestor: string;
  faibash: string;
  cashInDate: Date;
  cashInByMechanic: string;
  cashInTotal: number;
  cashInitialDate: Date;
  policySheetCompliedWith: string;
  hwModStatus: string;
  swLevel: string;
  pendingTotalAircraftTimeAtInstall: number;
  pendingTotalCyclesAtInstall: number;
  pendingAircraft: string;
  pendingAircraftPosition: string;
  pendingStation: string;
  pendingDepartment: string;
  maintenanceResolutionCode: string;
  maintenanceResolutionPafNumber: string;
  ldgAuditFlag: string;
  crpWordOrder: string;
  addTime: Date;
  addUserId: string;
  beaconId: string;
  versionNumber: number;
  artifactOid: number;
  inboundWeight: number;
  outboundWeight: number;
  thermalReadingFlag: string;
  dataWarehouseLoadTimestamp: Date;
  shelfLifeSpecType: string;
  shelfLifeSpec: number;
  shelfLifeDueDate: Date;
  shelfLifeSpecDesc: string;
  shelfLifeDaysRemaining: number;
  shelfLifeLastAccomplishDate: Date;
  shelfLifeDaysSince: number;
  shelfLifeSpecSequence: number;
  arlIndicator: number;
  arlAircraft: string;
  arlAcquisitionDate: Date;
  arlFleet: string;
}
